export default {
  UNSCORED: 0,
  SCORED: 1,
  IN_PROGRESS: 2,
  NEEDS_APPROVAL: 3,
  CANNOT_SCORE: 4,
  CANNOT_SCORE_APPROVAL: 5,
} as const
